import React, { useState,useEffect } from 'react'
import { Dialog, DialogContent, DialogTitle, Tooltip, LinearProgress } from "@mui/material";
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import { Add } from '@mui/icons-material';
import FormikControl from '../../../../../../components/FormikControl/FormikControl';
import voucherServices from '../voucherServices';
import { useAlert } from '../../../../../../context/AlertContext';
import { useAppData } from '../../../../../../context/AppDataContext';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';
import { useKeyPress } from '../../../../../../hooks/useKeyPress';

function ContraVoucherForm({ data, callBack }) {
    const { AppAlert } = useAlert();
    const { ledgerDD } = useAppData();
    const [dialogStatus, setDialogStatus] = useState(false);
    const [savingInProgress, setSavingStatus] = useState(false);
    const [formValues, setFormValues] = useState(null);

    const navigate = useNavigate();

    // Filter: Only show financial accounts for both sides of a Contra entry
    const bankCashLedgers = ledgerDD.filter(l => 
        ['Bank Accounts', 'Cash-in-Hand', 'Bank OCC A/c', 'Bank OD A/c'].includes(l.groupTitle)
    );

    const initialValues = {
        voucherType: 'Contra',        
        voucherNo: "",
        refNo: "",
        voucherDate: moment().format(moment.HTML5_FMT.DATE),
        ledgerId: "",           // Debit Ledger (Receiver)
        paymentLedgerId: "",    // Credit Ledger (Giver)
        grandTotal: "",
        instrumentNo: "",
        instrumentDate: moment().format(moment.HTML5_FMT.DATE),
        narration: "",
    }

    const updateData = ()=>{
        let autoFill = {
            id:data.id,
            voucherType: data.voucherType,      
            voucherNo: data.voucherNo,
            refNo:data.refNo,
            voucherDate: data.voucherDate,
            ledgerId: data.ledgerId,
            paymentLedgerId: data.paymentLedgerId,
            grandTotal: data.grandTotal,
            instrumentNo:data.instrumentNo,
            instrumentDate: data.instrumentDate,
            narration: data.narration
        }
        setFormValues(autoFill);
        setDialogStatus(true)
    }
    const addNew = ()=>{
        setFormValues(initialValues);
        setDialogStatus(true)
    }

    const validationRule = Yup.object({
        // voucherNo: Yup.string().required("Required"),
        voucherDate: Yup.string().required("Required"),
        // Validation: Ensure Debit Account is selected
        ledgerId: Yup.string().required("Receiver Ledger Required"),
        // Validation: Ensure Credit Account is selected AND not equal to Debit Account
        paymentLedgerId: Yup.string()
            .required("Giver Ledger Required")
            .test('not-same', 'Source and Destination accounts cannot be the same', function(value) {
                return value !== this.parent.ledgerId;
            }),
        grandTotal: Yup.number().moreThan(0, 'Amount cannot be zero').required("Required"),
    });

    const onSubmit = (values) => {
        if(values.ledgerId === values.paymentLedgerId) {
            AppAlert("Both accounts cannot be the same", "error");
            return;
        }
        setSavingStatus(true);
        voucherServices.save(values).then(res => {
            AppAlert(res.msg);
            if (!data) navigate("/voucher/contra-journal/details/" + res.id);
            if (callBack) callBack();
            setDialogStatus(false);
        }).catch(error => {
            AppAlert(error.msg, "error");
        }).finally(() => setSavingStatus(false));
    }

    useKeyPress('F4', addNew);

    return (
        <>
            {!data ? (
                <Tooltip title="Add New Contra">
                    <button type="button" className='btn btn-default w-100 text-start' onClick={addNew}>
                        <Add/> Contra Voucher 
                        <span style={{ fontSize: '0.85em', opacity: 0.7, marginLeft: '8px' }}>(F4)</span>
                    </button>
                </Tooltip>
            ) : (
                <button className="btn btn-outline-primary me-2" onClick={updateData}>Edit Contra Voucher</button>
            )}

            <Dialog open={dialogStatus} onClose={() => setDialogStatus(false)} fullWidth maxWidth="md">
                <Formik
                    initialValues={formValues || initialValues}
                    validationSchema={validationRule}
                    onSubmit={onSubmit}
                    enableReinitialize
                >
                    {(formik) => (
                        <Form>
                            <DialogTitle>Contra Voucher (Internal Transfer)</DialogTitle>
                            <DialogContent>
                                {data &&
                                <div className="row bg-light-primary">
                                    {/*
                                    <div className="col-md-6 my-2">
                                        <FormikControl control="input" formik={formik} type="text" label="Voucher Number" name="voucherNo" />
                                    </div>
                                    */}
                                    <div className="col-md-6 my-2">
                                        <FormikControl control="input" formik={formik} type="date" label="Voucher Date" name="voucherDate" />
                                    </div>
                                    <hr />
                                </div>
                                
                                }
                                
                                <div className='row'>

                                    <div className="col-md-6 my-2">
                                        <FormikControl control="input" autoFocus formik={formik} type="number" label="Transfer Amount" name="grandTotal" />
                                    </div>
                                    <div className="col-md-6 my-2">
                                        <FormikControl control="input" formik={formik} type="text" label="Ref/Cheque No" name="instrumentNo" />
                                    </div>

                                    <div className='col-md-6 my-2'>
                                        <FormikControl control="autoselect" formik={formik} 
                                            label="Debit Account (Receiver)" name="ledgerId" 
                                            options={bankCashLedgers} multiple={false} 
                                        />
                                    </div>
                                    <div className='col-md-6 my-2'>
                                        <FormikControl control="autoselect" formik={formik} 
                                            label="Credit Account (Giver)" name="paymentLedgerId" 
                                            options={bankCashLedgers} multiple={false} 
                                        />
                                    </div>
                                    
                                    <div className="col-md-12 my-2">
                                        <FormikControl control="input" formik={formik} type="text" multiline={true} label="Narration" name="narration" />
                                    </div>
                                </div>
                                <div className="row mt-3">
                                    <div className='col-md-12'>
                                        {savingInProgress ? <LinearProgress/> : (
                                            <>
                                                <button className="btn btn-primary float-end" type="submit">Save Contra</button>
                                                <button className="btn btn-outline-primary" type="button" onClick={() => setDialogStatus(false)}>Cancel</button>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </DialogContent>
                        </Form>
                    )}
                </Formik>
            </Dialog>
        </>
    )
}

export default ContraVoucherForm;